export default __webpack_public_path__ + "ae5475c924c5ae6e8f3b2833e737ca9b.svg";